<form
	*transloco="let t"
	[formGroup]="controller.form"
	(ngSubmit)="handleSubmit($event)"
>
	<base-input
		type="text"
		id="input-username"
		formControlName="username"
		[placeholder]="t('user.username')"
	/>
	@if (controller.fieldError('username'); as key) {
		<span class="field-error" role="alert">{{ t(key) }}</span>
	}

	<base-input
		id="input-password"
		formControlName="password"
		autocomplete="current-password"
		[type]="controller.passwordType()"
		[iconRight]="controller.passwordIcon()"
		[placeholder]="t('user.password')"
		[rightContentClickable]="true"
		(iconClicked)="controller.togglePasswordVisibility()"
	/>
	@if (controller.fieldError('password'); as key) {
		<span class="field-error" role="alert">{{ t(key) }}</span>
	}

	@if (siteConfigService.config.allowResetPassword) {
		<base-button
			variant="none"
			class="btn-forgot-password"
			(click)="controller.forgotPassword()"
		>
			{{ t('actions.forgotPassword') }}
		</base-button>
	}

	@if (controller.error(); as error) {
		<p class="form-error" role="alert">{{ error }}</p>
	}

	<login-button
		class="login-btn"
		[class.after-error]="controller.error()"
		[block]="true"
		[loading]="controller.submitting()"
		[variant]="surface() === 'light' ? 'success' : 'secondary'"
	/>
	@if (siteConfigService.config.allowPlayerRegistrationOnSite) {
		<!-- The auth modal asks in a line of text; the login page keeps the button. -->
		@if (surface() === 'light') {
			<register-prompt class="register-prompt" (navigated)="registering.emit()" />
		} @else {
			<register-button class="register-btn" [block]="true" />
		}
	}
</form>
